module.exports = "\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/home-grid/home-grid.component.html
// module id = ./src/app/main/home-grid/home-grid.component.html
// module chunks = main